import { render, staticRenderFns } from "./DamageAssessorCasePersonCard.vue?vue&type=template&id=180993ad"
import script from "./DamageAssessorCasePersonCard.vue?vue&type=script&lang=js"
export * from "./DamageAssessorCasePersonCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports